import axios from "axios";
import { getRotaPath } from "../lib/white-cache";

export const deleteExtraSharedPointOfSale = async (
  id: string
): Promise<boolean> => {
  try {
    await axios.delete(`${getRotaPath()}/ExtraSharedCalendarPointOfSale/${id}`);
    return true;
  } catch (error) {
    return false;
  }
};
